import { useI18n } from '@udemy/i18n';
import classNames from 'classnames';
import React from 'react';
import styles from "./notification-badge.module.css";
/** React props interface for the `NotificationBadge` component */

/** NotificationBadge component used to alert a user of a pressing communication  */
export const NotificationBadge = _ref => {
  let {
    label,
    children = null,
    className,
    ...htmlProps
  } = _ref;
  const {
    gettext
  } = useI18n();
  const isDot = children === null;
  const classes = classNames(className, styles['ud-notification-badge'], isDot ? styles['ud-notification-dot'] : styles['ud-notification-counter']);
  let content = children;

  if (!isDot) {
    const count = typeof children === 'string' ? parseInt(children, 10) : children;

    if (!count || count <= 0) {
      return null;
    }

    if (count && count > 9) {
      content = gettext('9+');
    }
  }

  return /*#__PURE__*/React.createElement("span", Object.assign({}, htmlProps, {
    className: classes,
    title: label
  }), content);
};
//# sourceMappingURL=notification-badge.react-component.js.map